import { Component, Prop, Vue } from 'vue-property-decorator';
import CalendarDay from './CalendarDay.vue';
@Component({
    name: 'CalendarMonth',
    components: { CalendarDay },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    month;
    @Prop({ required: true })
    focusedDate;
    @Prop({ required: true })
    displayPrices;
    @Prop()
    capacityThreshold;
    get classes() {
        return {
            'show-prices': this.displayPrices,
            'show-availability': this.capacityThreshold,
        };
    }
}
